"use client";

import React from "react";
import { motion } from "framer-motion";
import { BadgeCheck, MapPin, ShieldCheck, Headphones, Lock } from "lucide-react";

const badges = [
  { icon: BadgeCheck, label: "Verified Vendors", desc: "Every seller is screened before listing." },
  { icon: MapPin, label: "Pickup Verification", desc: "Confirm availability before you travel." },
  { icon: ShieldCheck, label: "Warranty Included", desc: "Eligible products carry a manufacturer warranty." },
  { icon: Headphones, label: "After-sales Support", desc: "Dedicated support after every transaction." },
  { icon: Lock, label: "Secure Payment", desc: "Payments processed through Paystack." },
];

function BadgeItem({ icon: Icon, label, desc }: { icon: React.ElementType; label: string; desc: string }) {
  return (
    <div className="flex items-center gap-2.5 group flex-shrink-0" title={desc}>
      <div className="w-9 h-9 rounded-full bg-white border border-[#002301]/10 flex items-center justify-center shadow-sm group-hover:shadow-md group-hover:border-[#17BC2E]/40 transition-all duration-300">
        <Icon className="w-4 h-4 text-[#002301]" />
      </div>
      <span className="text-sm font-medium text-[#002301] whitespace-nowrap">{label}</span>
    </div>
  );
}

export default function TrustBadgesSection() {
  return (
    <section className="bg-[#f0f7f0] border-b border-[#002301]/8 py-6 overflow-hidden">
      {/* Mobile: scrolling marquee */}
      <div className="sm:hidden">
        <div className="flex animate-marquee-badges gap-8 w-max px-4">
          {[...badges, ...badges].map(({ icon, label, desc }, i) => (
            <BadgeItem key={i} icon={icon} label={label} desc={desc} />
          ))}
        </div>
      </div>

      {/* Desktop: static flex wrap */}
      <div className="hidden sm:block max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-wrap items-center justify-center gap-4 sm:gap-8">
          {badges.map(({ icon: Icon, label, desc }, i) => (
            <motion.div
              key={label}
              initial={{ opacity: 0, y: 10 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.08, duration: 0.4 }}
              className="flex items-center gap-2.5 group"
              title={desc}
            >
              <div className="w-9 h-9 rounded-full bg-white border border-[#002301]/10 flex items-center justify-center shadow-sm group-hover:shadow-md group-hover:border-[#17BC2E]/40 transition-all duration-300">
                <Icon className="w-4 h-4 text-[#002301]" />
              </div>
              <span className="text-sm font-medium text-[#002301]">{label}</span>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
